import { render, staticRenderFns } from "./ArchivedChantierAdmin.vue?vue&type=template&id=3f855525&scoped=true&"
import script from "./ArchivedChantierAdmin.vue?vue&type=script&lang=js&"
export * from "./ArchivedChantierAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedChantierAdmin.vue?vue&type=style&index=0&id=3f855525&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f855525",
  null
  
)

export default component.exports